// extracted by mini-css-extract-plugin
export default {"container":"SZGZ","goBack":"c6mP","fields":"zw0w"};